module.exports = __webpack_public_path__ + "img/noData.7b4e8157.png";